import { fakerRU as faker } from '@faker-js/faker';
import { SaleWaterType, type SalesItem } from 'services/sales/types';
import { type NumericPaymentStatInfo } from 'types';

export const stats = {
  '1755118800000': {
    Banknotes: 6550,
    Coins: 4515,
    Cash: 9029,
    Bankcard: 2481,
    MobileApp: 1235,
    Exchange: 2036,
    Amount: 11510,
    Litres: 2306
  },
  '1755205200000': {
    Banknotes: 5150,
    Coins: 3318,
    Cash: 6891,
    Bankcard: 2748,
    MobileApp: 1245,
    Exchange: 1577,
    Amount: 9639,
    Litres: 1946
  },
  '1755291600000': {
    Banknotes: 4450,
    Coins: 3072,
    Cash: 5480,
    Bankcard: 3523,
    MobileApp: 5124,
    Exchange: 2042,
    Amount: 9003,
    Litres: 1882
  },
  '1755378000000': {
    Banknotes: 5450,
    Coins: 4708,
    Cash: 8127,
    Bankcard: 3017,
    MobileApp: 2345,
    Exchange: 2031,
    Amount: 11144,
    Litres: 2235
  },
  '1755464400000': {
    Banknotes: 4150,
    Coins: 4281,
    Cash: 7119,
    Bankcard: 3715,
    MobileApp: 5212,
    Exchange: 1312,
    Amount: 10834,
    Litres: 2205
  },
  '1755550800000': {
    Banknotes: 2450,
    Coins: 3765,
    Cash: 5107,
    Bankcard: 4296,
    MobileApp: 1252,
    Exchange: 1108,
    Amount: 9403,
    Litres: 1934
  },
  '1755637200000': {
    Banknotes: 3950,
    Coins: 3135,
    Cash: 5719,
    Bankcard: 3392,
    MobileApp: 2550,
    Exchange: 1366,
    Amount: 9111,
    Litres: 1856
  },
  '1755723600000': {
    Banknotes: 6150,
    Coins: 6736,
    Cash: 10474,
    Bankcard: 2508,
    MobileApp: 5252,
    Exchange: 2412,
    Amount: 12982,
    Litres: 2670
  }
};

export const sum = {
  Currency: {
    Code: 'RUB',
    Sign: '₽'
  },
  Sum: [
    {
      WaterType: 0,
      Banknotes: faker.number.int({ min: 1000, max: 10000 }),
      Coins: faker.number.int({ min: 1000, max: 10000 }),
      Bankcard: faker.number.int({ min: 1000, max: 10000 }),
      MobileApp: faker.number.int({ min: 1000, max: 10000 }),
      Exchange: faker.number.int({ min: 100, max: 1000 }),
      Amount: faker.number.int({ min: 1000, max: 10000 }),
      Litres: faker.number.int({ min: 1000, max: 10000 })
    },
    {
      WaterType: 1,
      Banknotes: faker.number.int({ min: 1000, max: 10000 }),
      Coins: faker.number.int({ min: 1000, max: 10000 }),
      Bankcard: faker.number.int({ min: 1000, max: 10000 }),
      MobileApp: faker.number.int({ min: 1000, max: 10000 }),
      Exchange: faker.number.int({ min: 100, max: 1000 }),
      Amount: faker.number.int({ min: 1000, max: 10000 }),
      Litres: faker.number.int({ min: 1000, max: 10000 })
    }
  ],
  Litres: faker.number.int({ min: 1000, max: 10000 }),
  Banknotes: faker.number.int({ min: 1000, max: 10000 }),
  Coins: faker.number.int({ min: 1000, max: 10000 }),
  Exchange: faker.number.int({ min: 100, max: 1000 }),
  Bankcard: faker.number.int({ min: 1000, max: 10000 }),
  MobileApp: faker.number.int({ min: 1000, max: 10000 }),
  Amount: faker.number.int({ min: 1000, max: 10000 }),
  Cashbox: {
    Banknotes: faker.number.int({ min: 10000, max: 100000 }),
    Coins: faker.number.int({ min: 10000, max: 100000 })
  }
};

export const deviceSales = {
  Currency: {
    Code: 'RUB',
    Sign: '₽'
  },
  Items: faker.helpers
    .multiple(
      () => {
        const Litres = faker.number.int({ min: 1, max: 30 });
        const DeviceTimestamp = +faker.date.recent({ days: 30 });
        const IsMineral = faker.datatype.boolean();
        const Amount = Litres * (IsMineral ? 10 : 5);
        const amounts: Omit<
          NumericPaymentStatInfo,
          'Litres' | 'Amount' | 'Exchange'
        > = {
          Banknotes: null,
          Coins: null,
          Bankcard: null,
          MobileApp: null
        };

        const randomField = faker.helpers.arrayElement(
          Object.keys(amounts)
        ) as keyof typeof amounts;

        amounts[randomField] = Amount;

        return {
          ...amounts,
          Exchange: faker.number.int({ min: 0, max: 10 }),
          Amount,
          Litres,
          DeviceTimestamp,
          DeviceLocalTime: '',
          Dt: DeviceTimestamp,
          SId: '',
          Moneypured: Amount,
          IsMineral,
          WaterType: IsMineral ? SaleWaterType.Mineral : SaleWaterType.Osmos
        } satisfies SalesItem;
      },
      { count: 10 }
    )
    .sort((a, b) => a.DeviceTimestamp - b.DeviceTimestamp)
    .map((item, idx, arr) => ({
      ...item,
      SId: arr.length - idx
    }))
};
